import { Trans } from '@common/i18n/trans';
import { Button } from '@common/ui/buttons/button';
import { Link } from 'react-router-dom';


export function ViewResult({
  item,
  pindex,
}: {item: any, pindex: number}) {
  if (item) {
    return (
      <div className='flex w-full gap-10'>
       <span className={item.is_ok ? `text-green font-bold mt-6`: 'font-bold text-red mt-6'}> {typeof item.uw_status === 'string' ? item.uw_status: ''}</span>
        <Button size={'xs'} 
          variant="outline" 
          color="orange"
          to={`/loan-products/${ item.id}/loan-program-view`}
          target='_blank'
          elementType={Link}
          >
          <Trans message="View Detail" />
        </Button>
      </div>
    );
  } else {
    return (<></>);
  }
}
